<template>
  <router-view />
</template>
<script>
//axios 전역으로 선언
import { onMounted } from "vue";
import { tracker } from "@/main";
import { useStore } from "vuex";
export default {
  name: "App",
  setup() {
    const store = useStore();

    onMounted(() => {
      const integratedUserVuex = JSON.parse(
        localStorage.getItem("integratedUserVuex"),
      );
      const userInfo = integratedUserVuex?.userInfo;
      const userName = userInfo?.userName;
      if (userName) {
        tracker.setUserID(userName);
      }
    });
  },
};
</script>
<style lang="scss"></style>
